import React from "react";

import { Icon, IconSize } from "@gaming/xds-react-js";
import { Achievements } from "@gaming/xds-react-js-icons";

import * as styles from "./AchievementIcon.module.css";

export const AchievementIcon = () => (
  <Icon className={styles.achievementIcon} icon={Achievements} iconSize={IconSize.Custom} />
);
